//相同部分
export var API_KEY = "PfjuEIOoInZZXvyVVakrSinMe";
export var SECRET_KEY = "HJdq=ZT?l?yp1)V)ZbRYw#E/il;&d,Nl"; //horoscrope

export var BASE_URL = "http://horoscope.ohippo.com";
export var UA = "Horoscope/46 CFNetwork/978.0.7 Darwin/18.5.0";
export var HORO_ARTICLE_LIST = "/api/article/v2/get_list";
export var HORO_ARTICLE_DETAIL = "/api/article/get_content";